export const setEstados = (estados) =>
  localStorage.setItem("estados", JSON.stringify(estados));
export const getEstados = () => JSON.parse(localStorage.getItem("estados"));
